import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { LogsModalModule } from 'projects/cpa/src/app/pages/modal-pages/logs-modal/logs-modal.module';

@NgModule({
  declarations: [FooterComponent],
  imports: [
    CommonModule, LogsModalModule
  ],
  exports: [FooterComponent]
})
export class FooterModule { }
